export interface CVUploadResultModel {
  document_id: string | null;
}
